(function () {
    //get the formApp module
    var formApp = angular.module('formApp');

    //set the controller to the code here - the controller uses DataServices.
    formApp.controller('followUpController',
        ['$scope', '$http', '$q', '$controller', 'DataServices', 'UtilityServices', 'ValidationService', '$location', '$routeParams', '$rootScope', 'Constants', 'feedbackType', 'incidentId',
    function ($scope, $http, $q, $controller, DataServices, UtilityServices, ValidationService, $location, $routeParams, $rootScope, Constants, feedbackType, incidentId) {

        // Store the type of Feedback we are co-orindating for
        $scope.feedbackType = feedbackType;
        $scope.incidentId = incidentId;

        // Setup the appropriate template and URL
        switch (feedbackType) {
            case Constants.FeedbackType.Privacy:
                $scope.coordinationTemplate = Constants.ConfigTemplate.incidentCoordination;
                $scope.firstCoordinationPageUrl = Constants.Url.firstFollowUpFormPage;
                break;

            case Constants.FeedbackType.Complaint:
                $scope.coordinationTemplate = Constants.ConfigTemplate.feedbackCoordination;
                $scope.firstCoordinationPageUrl = Constants.Url.firstFeedbackCoordinationFormPage;
                break;
        }


        if ($scope.pageId == "1-1") {
            $scope.originalResponse = angular.copy($scope.responses);
        }

        // return the user to coordination page for the feedback type
        $scope.returnToCoordinationPage = function () {

            // Reset original response (used to compare on save)
            DataServices.originalResponse = {};
            DataServices.resetResponseInfo();
            DataServices.responseInfo.responses = {};
            DataServices.responseInfo.status = 1;
            DataServices.responseInfo.incidentId = $scope.incidentId;
            DataServices.responseInfo.incidentRef = $scope.incidentRef;

            DataServices.getConfigurationUsingCache($scope.coordinationTemplate, null, null, DataServices.isAuthenticated())
                .then(function (data) {
                    $location.path($scope.firstCoordinationPageUrl);
                }, function (data) {
                    $scope.utility.showNotification(true, 'internalError');
                });
        }

        $scope.callSaveFollowUp = function () {
            $scope.isSaving = true;

            return DataServices.saveFollowUp($scope.feedbackType)
                .then(function (response) {
                    if (response.data && response.data.status === 2) {
                        return $scope.utility.openPopup('savedElsewhere', { lastUpdatedBy: response.data.lastUpdatedBy }).result;
                    } else {
                        if (response.data && response.data.id) {
                            DataServices.trackEventsWithGA('Save action in ' + $scope.pageUrl, 'Click Save followup', 'Successfully Saved followup');
                            return $scope.utility.openPopup('successSaveReport').result;
                        } else {
                            return $scope.utility.showNotification(true, 'internalError', null, true);
                        }
                    }
                }, function (response) {
                    DataServices.trackEventsWithGA('Error occured during Saving in ' + $scope.pageUrl, 'Click Save followup', 'Failed to Save on followup');
                    return $scope.utility.openPopup('errorSave').result;
                })
                .finally(function () {
                    $scope.isSaving = false;
                });
        };

        $scope.callSubmitFollowUp = function () {
            $scope.isSaving = true;

            return DataServices.submitFollowUp($scope.feedbackType)
                .then(function (response) {
                    if (response.data && response.data.status === 2) {
                        return $scope.utility.openPopup('savedElsewhere', { lastUpdatedBy: response.data.lastUpdatedBy }).result;
                    }
                    else {
                        if (response.data && response.data.id) {
                            DataServices.trackEventsWithGA('Submit action in ' + $scope.pageUrl, 'Click Submit Followup', 'Successfully Submitted Followup');
                            $scope.originalResponse = angular.copy($scope.responses);
                            return $scope.utility.openPopup('successSubmitReport').result;
                        }
                        else {
                            return $scope.utility.showNotification(true, 'internalError',null, true);
                        }
                    }
                }, function (response) {
                    DataServices.trackEventsWithGA('Error occured during Submitting in ' + $scope.pageUrl, 'Click Submit Followup', 'Successfully Submitted Followup');
                    return $scope.utility.openPopup('errorSubmit').result;
                })
                .finally(function () {
                    $scope.isSaving = false;
                });
        };
       
       
        $scope.callCancelFollowUp = function () {

            if ($scope.isPageEditable && $scope.confirmUserCancel()) {
                $scope.utility.openPopup('warnUserBeforeCancel').result.then(
                    function (data) {
                        if (data.result == "thirdButtonClick") {
                            if ($scope.status === Constants.FollowUpStatus.submitted) {
                                // submit the changes 
                                $scope.callSubmitFollowUp().then(function () {
                                    $scope.returnToCoordinationPage();
                                });
                            }
                            else {
                                // save changed
                                $scope.callSaveFollowUp().then(function () {
                                    $scope.returnToCoordinationPage();
                                });
                            }
                        }
                        else {
                            $scope.returnToCoordinationPage();
                        }
                    });
            }
            else {
                $scope.returnToCoordinationPage();
            }
        };
    }]);
}());